(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/';
  var ICONS = {
    chevron: CDN + 'wd-compare-choose-svg.svg?v=1682313834',
    close: CDN + 'wd-compare-close-svg.svg?v=1682313835',
    drain: {
      '1:1': CDN + 'wd-compare-1_1-svg.svg?v=1682313834',
      '2:1': CDN + 'wd-compare-2_1-svg.svg?v=1682313834',
      '3:1': CDN + 'wd-compare-3_1-svg.svg?v=1682313834'
    },
    check: CDN + 'wd-compare-certification_test_svg.svg?v=1682313835',
    none: CDN + 'wd-compare-smart_none-svg.svg?v=1682313834',
    flow: CDN + 'wd-compare-flow-svg.svg?v=1682313834',
    capacityNone: CDN + 'wd-compare-water_capacity_none-svg.svg?v=1682313834',
    dispense: CDN + 'wd-compare-dispensing-svg.svg?v=1682313834',
    dispenseNone: CDN + 'wd-compare-dispensing_none-svg.svg?v=1682313835',
    tankNone: CDN + 'wd-compare-water-tank_none.svg?v=1682315144',
    install1: CDN + 'wd-compare-installation-1-svg.svg?v=1682313834',
    install2: CDN + 'wd-compare-installation-2-svg.svg?v=1682313834',
    dimensions: CDN + 'wd-compare-dimensions-svg.svg?v=1682313835',
    electricity: CDN + 'wd-compare-electricity-required-svg.svg?v=1682313835',
    warranty: CDN + 'wd-compare-warranty-svg.svg?v=1682315463',
    usage: CDN + 'wd-compare-usage_scenario-svg1.svg?v=1682313834',
    reduce: CDN + 'wd-compare-reduce-svg.svg?v=1682313834',
    annual: CDN + 'wd-compare-average-svg.svg?v=1682313835',
    filterLife: CDN + 'wd-compare-filter.svg?v=1682313834',
    tds: CDN + 'wd-compare-tds-svg.svg?v=1682313834',
    temperature: CDN + 'wd-compare-temperature-svg.svg?v=1682313834',
    uv: CDN + 'wd-compare-uv-svg.svg?v=1682313835',
    self: CDN + 'wd-compare-self-svg.svg?v=1682313834',
    faucet: CDN + 'wd-compare-smart-svg.svg?v=1682313835',
    faucetDigital: CDN + 'wd-contrast-ro-product-icon3.png?v=1715067027',
    volume: CDN + 'wd-compare-smart_none-svg.svg?v=1682313834',
    volumeIcon: CDN + 'wd-contrast-ro-product-icon4.png?v=1715067027',
    sound: CDN + 'wd-compare-sound-svg.svg?v=1682313834',
    cert: {
      nsf: { logo: CDN + 'wd-compare-page-icon-8.png?v=1685341817' },
      fcc: { logo: CDN + 'wd-compare-page-icon-2.png?v=1681377284' },
      ce: { logo: CDN + 'wd-compare-page-icon-3.png?v=1681377284' },
      reddot: {
        logo: CDN + 'wd-compare-page-icon-4.png?v=1681377284',
        logo_alt: CDN + 'wd-ro-contrast-2024-5-8-icon.png?v=1715131458'
      },
      sgs: { logo: CDN + 'wd-compare-page-icon-5.png?v=1681377284' },
      tuv: { logo: CDN + 'wd-compare-page-icon-6.png?v=1681377284' },
      ul: { logo: CDN + 'wd-compare-page-icon-7.png?v=1681377284' }
    }
  };

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function img(src, cls) {
    if (!src) return '';
    return '<img alt="" loading="lazy" decoding="async" src="' + esc(src) + '"' + (cls ? ' class="' + cls + '"' : '') + '>';
  }
  function svgWrap(src) {
    return '<div class="wd-compare-detail-item-svg">' + img(src) + '</div>';
  }
  function imgWrap(src) {
    return '<div class="wd-compare-detail-item-img">' + img(src) + '</div>';
  }
  function textWrap(str, cls) {
    if (!str) return '';
    return '<div class="' + (cls || 'wd-compare-detail-item-text') + '">' + esc(str) + '</div>';
  }
  function nl2br(str) {
    return esc(str).replace(/\n/g, '<br>');
  }
  function parseFilters(text) {
    if (!text) return [];
    return String(text)
      .split(/\n/)
      .map(function (line) {
        var p = line.split('|').map(function (s) {
          return s.trim();
        });
        if (!p[0]) return null;
        return { name: p[0], life: p[1] || '', image: p[2] || '', url: p[3] || '' };
      })
      .filter(Boolean);
  }
  function yesNo(on, yesSrc, noSrc) {
    return svgWrap(on ? yesSrc || ICONS.check : noSrc || ICONS.none);
  }
  function certHtml(key, mode) {
    if (!mode || mode === 'none') return svgWrap(ICONS.none);
    if (mode === 'check') return svgWrap(ICONS.check);
    var map = ICONS.cert[key] || {};
    var src = map[mode] || map.logo;
    if (!src) return svgWrap(ICONS.check);
    if (key === 'nsf' || key === 'reddot' || key === 'sgs') return imgWrap(src);
    return imgWrap(src);
  }
  function faucetHtml(mode) {
    if (mode === 'digital') return svgWrap(ICONS.faucetDigital);
    if (mode === 'check') return svgWrap(ICONS.faucet);
    return svgWrap(ICONS.none);
  }
  function volumeHtml(mode) {
    if (mode === 'icon') return svgWrap(ICONS.volumeIcon);
    if (mode === 'check') return svgWrap(ICONS.check);
    return svgWrap(ICONS.none);
  }

  function cellPure(p) {
    var src = ICONS.drain[p.pure_to_drain];
    return src ? svgWrap(src) : svgWrap(ICONS.none);
  }
  function cellFlowRate(p) {
    var html = '';
    if (p.flow_rate) html += textWrap(p.flow_rate);
    if (p.flow_rate_unit) html += '<div class="wd-compare-detail-item-subtext">' + esc(p.flow_rate_unit) + '</div>';
    if (p.fill_time) {
      html +=
        '<div class="wd-compare-detail-item-svg_text">' +
        img(ICONS.flow) +
        esc(p.fill_time) +
        '</div>';
    }
    if (p.glass_note) {
      html += '<div class="wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz">' + esc(p.glass_note) + '</div>';
    }
    return html;
  }
  function cellCapacity(p) {
    if (p.water_capacity) {
      var html = '<div class="wd-compare-detail-item-blacktext">' + esc(p.water_capacity) + '</div>';
      if (p.water_capacity_note) html += '<div class="wd-compare-detail-item-subtext">' + esc(p.water_capacity_note) + '</div>';
      return html;
    }
    return svgWrap(ICONS.capacityNone);
  }
  function cellDispense(p, labels) {
    return (
      yesNo(p.ambient_water, ICONS.dispense, ICONS.dispenseNone) +
      '<div class="wd-compare-detail-item-subtext">' +
      esc(labels.ambient) +
      '</div>' +
      yesNo(p.instant_hot, ICONS.dispense, ICONS.dispenseNone) +
      '<div class="wd-compare-detail-item-subtext">' +
      esc(labels.hot) +
      '</div>' +
      yesNo(p.chilled_water, ICONS.dispense, ICONS.dispenseNone) +
      '<div class="wd-compare-detail-item-subtext">' +
      esc(labels.chilled) +
      '</div>'
    );
  }
  function cellTank(p) {
    if (p.water_tank) return textWrap(p.water_tank);
    return svgWrap(ICONS.tankNone);
  }
  function cellInstall(p, labels) {
    return (
      yesNo(p.need_installation, ICONS.install1, ICONS.none) +
      '<div class="wd-compare-detail-item-subtext">' +
      esc(labels.need_install) +
      '</div>' +
      yesNo(p.drill_countertop, ICONS.install2, ICONS.none) +
      '<div class="wd-compare-detail-item-subtext">' +
      esc(labels.drill) +
      '</div>'
    );
  }
  function cellDimensions(p) {
    return svgWrap(ICONS.dimensions) + textWrap(p.dimensions || '');
  }
  function cellWarranty(p) {
    return svgWrap(ICONS.warranty) + textWrap(p.warranty || '');
  }
  function cellUsage(p) {
    return svgWrap(ICONS.usage) + textWrap(p.usage_scenario || '');
  }
  function cellReduce(p, labels) {
    var html = svgWrap(ICONS.reduce);
    if (p.reduce_highlight) html += textWrap(p.reduce_highlight);
    if (p.reduce_text) html += '<div class="wd-compare-detail-item-longtext">' + nl2br(p.reduce_text) + '</div>';
    if (p.reduce_report_url) {
      html +=
        '<div class="wd-compare-detail-item-a"><a href="' +
        esc(p.reduce_report_url) +
        '" target="_blank" rel="noopener">' +
        esc(labels.report) +
        '</a></div>';
    }
    return html;
  }
  function cellFilters(p) {
    var filters = parseFilters(p.filters);
    if (!filters.length) return svgWrap(ICONS.none);
    return filters
      .map(function (f) {
        var inner =
          (f.image ? imgWrap(f.image) : '') +
          textWrap(f.name) +
          (f.life ? textWrap(f.life) : '');
        if (f.url) inner = '<a href="' + esc(f.url) + '" target="_blank" rel="noopener">' + inner + '</a>';
        return '<div class="wd-compare-detail-item-a">' + inner + '</div>';
      })
      .join('');
  }
  function cellAnnual(p) {
    return svgWrap(ICONS.annual) + textWrap(p.annual_cost || '');
  }

  function renderPickerItems(products, selected, col) {
    return products
      .map(function (p, i) {
        var cls = 'wd-compare-detail-item-product-choose-card-item';
        if (selected[col] === i) cls += ' wd-compare-detail-item-product-choose-card-item-active';
        else if (selected.indexOf(i) !== -1) cls += ' wd-compare-detail-item-product-choose-card-item-choosed';
        return (
          '<div class="' +
          cls +
          '" data-index="' +
          i +
          '"' +
          (p.shopify_attributes ? ' ' + p.shopify_attributes : '') +
          '>' +
          '<div class="wd-compare-detail-item-product-choose-card-item-img">' +
          img(p.image) +
          '</div>' +
          '<div class="wd-compare-detail-item-product-choose-card-item-title">' +
          esc(p.title) +
          '</div>' +
          '<div class="wd-compare-detail-item-product-choose-card-item-sku">' +
          esc(p.sku || '') +
          '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function fillColumn(root, col, product, labels) {
    if (!product) return;
    qsa(root, '.wd-compare-header-item').forEach(function (el, i) {
      if (i !== col) return;
      var im = el.querySelector('img');
      if (im) {
        im.src = product.image || '';
        im.alt = product.title || '';
      }
      var t = el.querySelector('.wd-compare-header-item-title');
      if (t) t.textContent = product.title || '';
      var pr = el.querySelector('.wd-compare-header-item-price');
      if (pr) pr.textContent = product.price || '';
    });

    var colRoot = qsa(root, '.wd-compare-product .wd-compare-detail-item')[col];
    if (colRoot) {
      qsa(colRoot, '.wd-compare-detail-item-product-choose-name').forEach(function (el) {
        el.textContent = product.title || '';
      });
      var pimg = colRoot.querySelector('.wd-compare-detail-item-product-img img');
      if (pimg) {
        pimg.src = product.image || '';
        pimg.alt = product.title || '';
      }
      var price = colRoot.querySelector('.wd-compare-detail-item-product-price');
      if (price) price.textContent = product.price || '';
      var shop = colRoot.querySelector('.wd-compare-detail-item-product-shop a');
      if (shop) {
        shop.href = product.url || '#';
        shop.textContent = labels.shop;
      }
    }

    function setRow(name, html) {
      qsa(root, '[data-row="' + name + '"] [data-col="' + col + '"]').forEach(function (el) {
        el.innerHTML = html;
      });
    }

    setRow('pure', cellPure(product));
    setRow('flow_capacity', textWrap(product.flow_capacity || ''));
    setRow('flow_rate', cellFlowRate(product));
    setRow('water_capacity', cellCapacity(product));
    setRow('dispensing', cellDispense(product, labels));
    setRow('tank', cellTank(product));
    setRow('installation', cellInstall(product, labels));
    setRow('dimensions', cellDimensions(product));
    setRow('weight', textWrap(product.weight || ''));
    setRow('electricity', yesNo(product.electricity_required, ICONS.electricity, ICONS.none));
    setRow('warranty', cellWarranty(product));
    setRow('usage', cellUsage(product));
    setRow('nsf', certHtml('nsf', product.cert_nsf));
    setRow('fcc', certHtml('fcc', product.cert_fcc));
    setRow('ce', certHtml('ce', product.cert_ce));
    setRow('reddot', certHtml('reddot', product.cert_reddot));
    setRow('sgs', certHtml('sgs', product.cert_sgs));
    setRow('tuv', certHtml('tuv', product.cert_tuv));
    setRow('ul', certHtml('ul', product.cert_ul));
    setRow('stages', '<div class="wd-compare-detail-item-bigtext">' + esc(product.filtration_stages || '') + '</div>');
    setRow('reduce', cellReduce(product, labels));
    setRow('filters', cellFilters(product));
    setRow('annual', cellAnnual(product));
    setRow('feature_filter_life', yesNo(product.feature_filter_life, ICONS.filterLife, ICONS.none));
    setRow('feature_tds', yesNo(product.feature_tds, ICONS.tds, ICONS.none));
    setRow('feature_temperature', yesNo(product.feature_temperature, ICONS.temperature, ICONS.none));
    setRow('feature_uv', yesNo(product.feature_uv, ICONS.uv, ICONS.none));
    setRow('feature_self_clean', yesNo(product.feature_self_clean, ICONS.self, ICONS.none));
    setRow('feature_smart_faucet', faucetHtml(product.feature_smart_faucet));
    setRow('feature_adjustable_volume', volumeHtml(product.feature_adjustable_volume));
    setRow('feature_sound', yesNo(product.feature_sound, ICONS.sound, ICONS.none));
  }

  function closePicker(root) {
    qsa(root, '.wd-compare-detail-item-product-choose-card').forEach(function (el) {
      el.style.display = 'none';
    });
    qsa(root, '.wd-compare-detail-item-product-choose-card-popup').forEach(function (el) {
      el.style.display = 'none';
    });
    qsa(root, '.wd-compare-detail-item-product-choose-card-popup-close').forEach(function (el) {
      el.style.display = 'none';
    });
    qsa(root, '.wd-compare-detail-item-product-choose-select-mobile').forEach(function (el) {
      el.style.display = 'none';
    });
    document.documentElement.style.overflow = '';
    root.style.zIndex = '';
  }

  function init(root) {
    if (!root || root.dataset.wdReady === 'true') return;
    var jsonEl = qs(root, '[data-wd-compare-json]');
    if (!jsonEl) return;
    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var products = data.products || [];
    var labels = data.labels || {};
    var colCount = Math.min(3, Math.max(1, parseInt(data.columns, 10) || 3));
    colCount = Math.min(colCount, Math.max(1, products.length));
    root.setAttribute('data-cols', String(colCount));
    root.dataset.wdReady = 'true';

    if (!products.length) return;

    var selected = [];
    for (var i = 0; i < colCount; i++) selected.push(i);

    function renderPickers() {
      qsa(root, '.js-wd-picker').forEach(function (el) {
        var col = parseInt(el.getAttribute('data-col'), 10);
        el.innerHTML = renderPickerItems(products, selected, col);
      });
    }

    function renderAll() {
      renderPickers();
      selected.forEach(function (prodIndex, col) {
        fillColumn(root, col, products[prodIndex], labels);
      });
    }

    var content = qs(root, '.wd-compare-content');
    var header = qs(root, '.wd-compare-header');
    function onScroll() {
      if (!content || !header) return;
      var top = content.getBoundingClientRect().top + window.pageYOffset;
      header.style.display = window.pageYOffset > top ? 'block' : 'none';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    root.addEventListener('click', function (e) {
      var select = e.target.closest('.wd-compare-detail-item-product-choose-select');
      if (select) {
        var item = select.closest('.wd-compare-detail-item');
        var card = item ? item.querySelector('.wd-compare-detail-item-product-choose-card') : null;
        var isMobile = window.innerWidth <= 767;
        qsa(root, '.wd-compare-detail-item-product-choose-card').forEach(function (el) {
          if (el !== card) el.style.display = 'none';
        });
        if (card) card.style.display = card.style.display === 'block' ? 'none' : 'block';
        if (isMobile) {
          qsa(root, '.wd-compare-detail-item-product-choose-card-popup').forEach(function (el) {
            el.style.display = 'block';
          });
          qsa(root, '.wd-compare-detail-item-product-choose-select-mobile').forEach(function (el) {
            el.style.display = 'flex';
          });
          qsa(root, '.wd-compare-detail-item-product-choose-card-popup-close').forEach(function (el) {
            el.style.display = 'block';
          });
          document.documentElement.style.overflow = 'hidden';
          root.style.zIndex = '99';
        }
        return;
      }

      if (e.target.closest('.wd-compare-detail-item-product-choose-card-popup-close')) {
        closePicker(root);
        return;
      }

      var cardItem = e.target.closest('.wd-compare-detail-item-product-choose-card-item');
      if (cardItem) {
        if (cardItem.classList.contains('wd-compare-detail-item-product-choose-card-item-choosed')) return;
        var picker = cardItem.closest('.js-wd-picker');
        var col = picker ? parseInt(picker.getAttribute('data-col'), 10) : -1;
        var idx = parseInt(cardItem.getAttribute('data-index'), 10);
        if (col < 0 || isNaN(idx)) return;
        selected[col] = idx;
        renderAll();
        closePicker(root);
      }
    });

    root.addEventListener('mouseover', function (e) {
      var item = e.target.closest('.wd-compare-detail-item-product-choose-card-item');
      if (item) item.classList.add('wd-compare-detail-item-product-choose-card-item-hover');
    });
    root.addEventListener('mouseout', function (e) {
      var item = e.target.closest('.wd-compare-detail-item-product-choose-card-item');
      if (item) item.classList.remove('wd-compare-detail-item-product-choose-card-item-hover');
    });

    qsa(root, '.wd-compare-detail-item-product-choose-card').forEach(function (card) {
      card.addEventListener('mouseleave', function () {
        if (window.innerWidth > 767) card.style.display = 'none';
      });
    });

    renderAll();
  }

  function boot() {
    qsa(document, '[data-wd-compare]').forEach(function (root) {
      root.dataset.wdReady = 'false';
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wd-compare]');
    if (root) {
      root.dataset.wdReady = 'false';
      init(root);
    }
  });
})();
